module.exports = __webpack_public_path__ + "media/images/icon/icons8-Restore Window-202564d3750b7793996f01815553fc98.png";